<template>
  <main>
    <b-container>
        <div class="section-header">
            <h1 class="heading">Error Log</h1>

            <div class="actions">
            <div class="action">
                <b-form-select v-model="tag" :options="tagSelect"></b-form-select>
            </div>
            <div class="action">
                <b-form-input v-model="search" placeholder="Search…"></b-form-input>
            </div>
            <!--
            <div class="action">
                <b-btn
                variant="primary"
                @click="$router.push({ name: 'ProjectCreate' })"
                ><i class="fa fa-plus" /> New project</b-btn
                >
            </div>
            -->
            </div>
        </div>
        <div class="layoutcard">
            <!-- This table is for loading placeholders.
            Use this when you implement lazy loading. -->
            <!-- <table class="table table-hover vertical-align-middle">
            <thead>
                <tr>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                <th>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                <td>
                    <div class="placeholder">
                    <div class="placeholder__tile"></div>
                    </div>
                </td>
                </tr>
            </tbody>
            </table> -->

            <b-table
            v-if="log"
            :show-empty="true"
            :items="log"
            :fields="fields"
            :filter="search"
            :current-page="currentPage"
            :per-page="perPage"
            class="table-hover vertical-align-middle"
            >
            <template v-slot:cell(endpoint)="data">
                <b-badge variant="light">{{ getEndPoint(data.item.endpoint) }}</b-badge>
            </template>
            <template v-slot:cell(request)="data">
                <div class="text-fix" :title="data.item.request" @click="viewError(data.item.request)">
                {{ data.item.request }} <b-btn variant="outline-secondary" size="sm" type="submit"><i class="fa fa-eye" /></b-btn> 
                </div>
            </template>
            <template v-slot:cell(error)="data">
                <b-badge variant="light">{{ data.item.error }}</b-badge>
            </template>
            <template v-slot:cell(date)="data">
                {{ data.item.date | moment("DD-MM-YYYY") }}
            </template>
            </b-table>

            <b-row align-h="center" class="mt-4" v-if="totalRows > perPage">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
            ></b-pagination>
            </b-row>
        </div>
    </b-container>
    <b-modal
        id="modal-error-detail"
        centered
        :title="header"
        hide-header
        :size="size || 'md'"
        :no-close-on-backdrop="true"
    >
        <code>{{ errorDetails }}</code>
    </b-modal>
  </main>
</template>

<script>
import { mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import _ from "lodash";

export default {
  name: "ErrorLog",
  components: {
  },
  extends: InitAdmin,
  data() {
    return {
      log: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      search: "",
      fields: [
        {
          key: "user",
        },
        {
          key: "endpoint",
        },
        {
          key: "request",
        },
        {
          key: "error",
        },
        {
          key: "date",
          tdClass: "text-right",
          thClass: "text-right",
          label: "Creation Date",
        },
      ],
      errorDetails: ""
    };
  },
  computed: {
  },
  mounted() {
    this.errorLog().then(logs => {
        this.log = logs;
        this.totalRows = this.log.length;
    });
  },
  methods: {
    ...mapActions(["errorLog"]),
    getEndPoint(str){
        return _.last(_.split(str, '/'))
    },
    viewError(req){
        this.errorDetails = req;
        this.$bvModal.show('modal-error-detail');
    }
  }
};
</script>